import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { getErrorHttpMessage } from "utils";
import { StoreType } from "types/genericTypes";
import { useIntl } from "react-intl";
import { getUsuarioPorIdHttp } from "actions/users";
import { setUser } from "actions/auth";

export const usePublic = () => {
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const intl = useIntl();

    const user = useSelector((state: StoreType) => state?.app?.user?.data);

    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [mensajeAlert, setMensajeAlert] = useState("");
    const [errorLogin, setErrorLogin] = useState(false);
    const handleisAlertOpen = () => setIsAlertOpen(true);
    const handleisAlertClose = () => setIsAlertOpen(false);
    const [procesando, setProcesando] = useState<boolean>(() => {
        return !!searchParams.get("id");
    });

    const getUsuarioPorId = useCallback(async (data: any) => {
        try {
            setProcesando(true);
            const response = await getUsuarioPorIdHttp(data);
            dispatch(setUser({ data: response }));
        } catch (error) {
            const message = getErrorHttpMessage(error);
            setMensajeAlert(message || intl.formatMessage({ id: "get_elementos_error" }));
            handleisAlertOpen();
        } finally {
            setProcesando(false);
        }
    }, []);

    useEffect(() => {
        const idUsuario = searchParams.get("id");

        if (!idUsuario) {
            setProcesando(false);
            return;
        }

        if (user?.id_usuario && String(user.id_usuario) === String(idUsuario)) {
            setProcesando(false);
            return;
        }

        getUsuarioPorId({ id_usuario: idUsuario });
    }, [searchParams]);

    return {
        user,
        procesando
    };
};
